import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import BottomNavigation from "../Components/BottomNavigation";
import TopNavigation from "../Components/TopNavigation";
import SocialMediaPost from "../Components/SocialMediaPost";

const SavedPost = () => {
  const [savedPosts, setSavedPosts] = useState([]);
  const loaderRef = useRef(null);

  // Retrieve the token from local storage
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");

        loaderRef.current.style.display = "block"; // Show the loader

        // Make the GET request with the auth header
        const response = await axios.get(
          "https://foodie-wirte.onrender.com/api/savedpost",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Retrieve the saved posts from the response data
        const savedPostsData = response.data;

        // Set the saved posts in the component state
        console.log(savedPostsData);
        setSavedPosts(savedPostsData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const ids = savedPosts
    .filter((post) => post.postID)
    .map((post) => ({
      postID: post.postID,
      isSaved: post.isSaved,
    }));

  const uniqueIds = Object.values(
    ids.reduce((obj, post) => {
      if (post.postID && !obj[post.postID]) {
        obj[post.postID] = {
          postID: post.postID,
          isSaved: post.isSaved,
        };
      }
      return obj;
    }, {})
  );

  console.log(uniqueIds);

  const [restaurants, setRestaurants] = useState([]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       if (uniqueIds.length > 0 && restaurants.length === 0) {
  //         const promises = uniqueIds.map(async (item) => {
  //           const response = await axios.get(
  //             `http://localhost:5000/api/restaurant/saved-posts?postIds=${item.postID}`,
  //             {
  //               headers: {
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //           return response.data.restaurants;
  //         });

  //         const results = await Promise.all(promises);
  //         const mergedRestaurants = results.flat();
  //         setRestaurants(mergedRestaurants);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   fetchData();
  // }, [restaurants, uniqueIds, token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (restaurants.length === 0 && uniqueIds.length > 0) {
          const requests = uniqueIds.map((item) =>
            axios.get(
              `https://foodie-read.onrender.com/api/restaurant/saved-posts?postIds=${item.postID}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
          );

          const responses = await Promise.all(requests);
          const mergedRestaurants = responses.flatMap(
            (response) => response.data.restaurants
          );
          setRestaurants(mergedRestaurants);
          loaderRef.current.style.display = "none"; // Hide the loader
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [restaurants, uniqueIds, token]);

  console.log("Restaurants: ", restaurants);

  const profileImgs = [
    "Cali",
    "George",
    "Milo",
    "Bandit",
    "Sheba",
    "Kitty",
    "Baby",
    "Socks",
    "Jasper",
    "Snuggles",
    "Pumpkin",
    "Boo",
    "Peanut",
    "Zoe",
    "Scooter",
    "Annie",
    "Smokey",
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <TopNavigation />
      <h1 className="text-xl font-bold mb-4 tracking-wide pt-20 ml-6">
        Saved Posts
      </h1>
      <div className="flex flex-col flex-grow items-center justify-center pt-4 pb-20 px-1">
        {restaurants ? (
          <div className="space-y-10">
            {restaurants &&
              restaurants.map((restaurant) => {
                // Generate a random index to select a random profile image
                const randomIndex = Math.floor(
                  Math.random() * profileImgs.length
                );
                const randomProfileImg = profileImgs[randomIndex];

                // Format the user name to have capitalized words
                const u_name =
                  restaurant && restaurant.userName
                    ? restaurant.userName
                        .toLowerCase()
                        .split(" ")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")
                    : "";

                // Render the SocialMediaPost component with the restaurant data
                return (
                  <SocialMediaPost
                    key={restaurant._id}
                    userName={u_name}
                    splDish={restaurant.splDish}
                    restaurantName={restaurant.restaurantName}
                    img={restaurant.img}
                    cost={restaurant.cost}
                    rating={restaurant.rating}
                    profilePic={`https://api.dicebear.com/6.x/pixel-art/svg?seed=${randomProfileImg}`}
                    postId={restaurant._id} // Replace "postId" with the actual post ID property
                    className="mr-4 mb-4"
                  />
                );
              })}
          </div>
        ) : (
          <h1 className="text-sm font-bold mb-4">Loading...</h1>
        )}
        <div
          ref={loaderRef}
          className="w-12 h-12 animate-spin rounded-full border-4 border-solid border-red-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          style={{ display: "none" }}
        ></div>
      </div>
      <BottomNavigation />
    </div>
  );
};

export default SavedPost;
